export function processRoomProducts(products, rootGetters) {
  return products
    .map((roomBuildProduct) => {
      const product = rootGetters['category-products/getProductById'](
        roomBuildProduct.id
      );

      if (!product) {
        return null;
      }

      return {
        id: product.id,
        categoryId: product.category_id,
        amount: roomBuildProduct.amount,
        isCoverFrame: product.is_cover_frame,
        coverFrameAmount: product.cover_frame_amount,
      };
    })
    .filter(Boolean);
}
